import styled from 'styled-components';

export const StyledTypeAheadFlyoutMobile = styled.div``;
